<template>
  <div class="mb-10">
    <div class="tags-header" v-if="showTitle">
      <h2 class="timetable__mimk-name">{{ $t('mc.tags.tags') }}:</h2>
<!--      <button class="btn btn_blue" @click="openAddTagModal()" style="max-width: 150px;">Добавить тэг</button>-->
    </div>
    <div class="tags" :style="tagsWrapperStyle || null">
      <div class="tag" v-for="tag in tags" :style="`color:${tag.font_color};background:${tag.background_color};${tagsStyle}`" :key="tag.tag_id">
        <inline-svg
            v-if="tag.flag_strict"
            class="tag-lock"
            v-tooltip="'Важный'"
            :src="isColorWhite(tag.font_color) ? require(`@/assets/svg/lock_white.svg`) : require(`@/assets/svg/lock.svg`)"
        />
        {{ tag.name }}
        <inline-svg
          v-if="modifyAbility"
          class="tag-delete"
          @click="deleteTag(tag.tag_id)"
          :src="isColorWhite(tag.font_color) ? require(`@/assets/svg/close_white.svg`) : require(`@/assets/svg/close.svg`)"
        />
      </div>
      <div class="tag tag--add" v-if="filteredTagsToSelect.length && modifyAbility" @click="openAddTagModal()">
        +
      </div>
      <div class="tag tag--add tag--disabled" v-else-if="modifyAbility">
        +
      </div>
    </div>
    <modal
      :heightOfScroll="220"
      v-if="addTagModal"
      :title="$t('mc.tags.addTag')"
      @close="closeAddTagModal"
      width="500px"
    >
      <template v-slot:body>
        <v-select
          v-model="tagsToAdd"
          class="tags__select"
          multiple
          :closeOnSelect="false"
          :options="filteredTagsToSelect"
          label="name"
          :clearable="false"
        />
      </template>
      <template v-slot:footer>
        <button
          class="btn btn_blue"
          @click="addTags()"
          style="margin-top:30px;max-width: 150px;"
          :disabled="tagsToAdd.length === 0"
        >
          {{ $t('mc.buttons.save') }}
        </button>
      </template>
    </modal>
  </div>
</template>
<style lang="scss">
  .tags {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &__select {
      & span.vs__selected {
        height: fit-content;
        margin-right: 2px;
        margin-bottom: 2px;
      }
      & .vs__dropdown-toggle {
        height: fit-content;
        padding: 3px;
      }
      & .vs__selected-options {
        height: fit-content;
      }
    }

    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
  }
  .tag {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 5px 13px;
    border-radius: 20px;
    font-size: 13px;
    &-lock {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
    &-delete {
      height: 11px;
      cursor: pointer;
      &:hover {
        opacity: 0.5;
      }
    }
    &--add {
      cursor: pointer;
      background: #007bff;
      padding: 1px 10px;
      font-size: 20px;
      color: #fff;
      &:hover {
        opacity: 0.5;
      }
    }
    &--disabled {
      cursor: default;
      opacity: 0.5;
    }
    &:hover {

    }
  }
</style>
<script>
import tagsApi from "@/api/tags";
import Vue from "vue";

export default {
  props: {
    // booking or mimk
    entityType: {
      type: String,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    tagsStyle: {
      type: String,
      default: '',
    },
    tagsWrapperStyle: {
      type: String,
    },
    entityId: [String, Number, Boolean],
    modifyAbility: {
      type: Boolean,
      default: true,
    },
    propTags: {
      type: Array,
    },
    propSegmentId: {
      type: Number, String,
    },
  },
  name: 'Tags',
  data() {
    return {
      addTagModal: false,
      tags: [],
      allTags: [],
      tagsToAdd: [],
    }
  },
  watch: {
    propSegmentId() {
      this.segmentId = this.propSegmentId
    }
  },
  created() {
    if (this.propSegmentId) {
      this.segmentId = this.propSegmentId
    } else {
      this.segmentId = this.$store.state.user.segment.id
    }
    if (this.propTags) {
      this.tags = this.propTags
      this.sortTags()
    } else {
      this.fetchTags()
    }

    if (this.modifyAbility) this.$emit('saveEntityTags', this.saveEntityTags)
  },
  computed: {
    validatedTags() {
      return this.tags.map(tag => +tag.tag_id || null).filter(tag => Number.isInteger(tag))
    },
    filteredTagsToSelect() {
      const currentTagsIds = this.tags.map(tag => +tag.tag_id)

      return this.allTags.filter(tag => !currentTagsIds.includes(+tag.tag_id))
    },
  },
  methods: {
    sortTags() {
      this.tags = this.tags.filter(tag => !!tag)
      this.tags = this.tags.sort((a, b) => b.priority - a.priority)
    },
    async fetchTags() {
      const allTags = await tagsApi.getSegmentTags(this.segmentId)
      this.allTags = allTags || []

      if (this.entityId) {
        const currentTags = await this.getCurrentEntityTags()
        this.tags = currentTags || []
        this.sortTags()
      }
    },
    async getCurrentEntityTags() {
      try {
        let data;
        if (this.entityType === 'mimk') {
          data = await tagsApi.getMimksTags([+this.entityId], this.segmentId)
        } else {
          data = await tagsApi.getBookingsTags([this.entityId])
        }

        return data[0].tags
      } catch (e) {
        console.log(e, 'error in getting entity tags')
        return []
      }
    },
    saveEntityTags(entityId = null) {
      const finalEntityId = entityId || this.entityId

      try {
        if (this.entityType === 'mimk') {
          return tagsApi.setMimkTags(+finalEntityId, this.segmentId, this.validatedTags)
        }

        return tagsApi.setBookingTags(finalEntityId, this.segmentId, this.validatedTags)
      } catch(e) {
        console.log(e)
        Vue.toasted.global.all_mistake(e)
      }
    },
    deleteEntityTags() {
      try {
        if (this.entityType === 'mimk') {
          return tagsApi.deleteMimkTags(+this.entityId, this.segmentId)
        }

        return tagsApi.deleteBookingTags(this.entityId, this.segmentId)
      } catch(e) {
        console.log(e)
      }
    },
    openAddTagModal() {
      this.addTagModal = true
    },
    async addTags() {
      if (!this.tagsToAdd.length) return

      this.tags.push(...this.tagsToAdd)
      this.sortTags()
      this.tagsToAdd = []
      if (this.entityId) {
        await this.saveEntityTags()
        Vue.toasted.global.all_ok(this.$t("ok.saved"))
      }

      this.closeAddTagModal()
    },
    closeAddTagModal() {
      this.addTagModal = false
    },
    isColorWhite(color = '') {
      return color.startsWith('#fff') || color === 'white'
    },
    async deleteTag(tagId) {
      this.tags = this.tags.filter(tag => tag.tag_id !== tagId)
      this.sortTags()
      if (this.entityId) {
        await this.saveEntityTags()
        Vue.toasted.global.all_ok(this.$t("ok.saved"))
      }
    }
  }
}
</script>